// extracted by mini-css-extract-plugin
module.exports = {"page-coaching":"coaching_page-coaching__1w8vr","section-coaching":"coaching_section-coaching__zcCkX","heading":"coaching_heading__1FPre"};